import { RelatorioExibidoComponent } from './../../../components/relatorios/relatorio-exibido/relatorioExibido/relatorioExibido.component';
import { Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FaturaService, AuthenticationService } from 'src/app/services';
import { ListaPaginada } from 'src/app/models';
import { IFechamento } from 'src/app/interfaces/fatura/IFechamento';
import { ActivatedRoute, Router } from '@angular/router';
import { downloadArquivoDeBase64 } from 'src/app/helper';
import { IToken } from 'src/app/interfaces/token/IToken';
import { ModalGeneralComponent } from 'src/app/components/modal-general/modal-general.component';

@Component({
  selector: 'app-listar-fechamento',
  templateUrl: './listar-fechamento.component.html',
  styleUrls: ['./listar-fechamento.component.scss']
})
export class ListarFechamentoComponent implements OnInit, OnDestroy {
  subscriptions$ = new Subscription();
  @ViewChild(ModalGeneralComponent) modalSucesso: ModalGeneralComponent;
  @ViewChild(RelatorioExibidoComponent)
  relatorioExibido: RelatorioExibidoComponent;
  dadosRota: {
    codContrato: string;
    mesAno: string;
    codFatura: string;
  };
  colunasVisiveis: string[] = [
    'numSerie',
    'marca',
    'modelo',
    'endereco',
    'acessorios',
    'anteriorPb',
    'atualPb',
    'producaoPb',
    'anteriorColor',
    'atualColor',
    'producaoColor'
  ];
  fechamentos = new ListaPaginada<IFechamento>();
  fechamentoPDFBase64: string;
  fechamentoCSVBase64: string;
  token: IToken;

  constructor(
    private faturaService: FaturaService,
    private authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}
  visualizarRelatorio() {
    this.relatorioExibido.openModal();
  }
  fecharModal() {
    this.router.navigate(['/demonstrativo-financeiro']);
    this.modalSucesso.closeModalWithoutReload();
  }
  obterFechamentos(reiniciarPaginacao?: boolean) {
    if (reiniciarPaginacao) {
      this.fechamentos.paginaAtual = 1;
    }

    this.subscriptions$.add(
      this.faturaService
        .getFechamento({
          idUsuario: this.token.id,
          codContrato: this.dadosRota.codContrato,
          mesAno: this.dadosRota.mesAno,
          itensPorPagina: this.fechamentos.itensPorPagina,
          paginaAtual: this.fechamentos.paginaAtual
        })
        .subscribe({
          next: ({ data }) => {
            this.fechamentos = data;
          }
        })
    );
  }
  getDownloadPDFFechamentos() {
    this.subscriptions$.add(
      this.faturaService
        .getDownloadPDFFechamento({
          idUsuario: this.token.id,
          codContrato: this.dadosRota.codContrato,
          mesAno: this.dadosRota.mesAno
        })
        .subscribe({
          next: ({ data }) => {
            this.fechamentoPDFBase64 = data;
            downloadArquivoDeBase64({
              nomeArquivo: `fechamento-${this.dadosRota.codContrato}-${this.dadosRota.codFatura}`,
              base64: data,
              tipo: 'application/pdf'
            });
          }
        })
    );
  }
  getDownloadCSVFechamentos() {
    this.subscriptions$.add(
      this.faturaService
        .getDownloadCSVFechamento({
          idUsuario: this.token.id,
          codContrato: this.dadosRota.codContrato,
          mesAno: this.dadosRota.mesAno
        })
        .subscribe({
          next: ({ data }) => {
            this.fechamentoCSVBase64 = data;
            downloadArquivoDeBase64({
              nomeArquivo: `fechamento-${this.dadosRota.codContrato}-${this.dadosRota.codFatura}`,
              base64: data,
              tipo: 'text/csv'
            });
          }
        })
    );
  }
  ngOnInit() {
    this.token = this.authenticationService.obterToken();
    this.dadosRota = this.activatedRoute.snapshot.params as this['dadosRota'];
    this.obterFechamentos();
  }
  ngOnDestroy() {
    this.subscriptions$.unsubscribe();
  }
}
